import { Injectable } from '@angular/core';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { Store } from '@ngxs/store';
import { ListServerPaginationStateModel, LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { Observable } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';
import { YardSpotConfigurationState } from './yard-spot-configuration.state';
import {
  YardSpotSave,
  YardSpotDelete,
  YardSpotListInitialState,
  YardSpotListLoad,
} from './yard-spot-configuration.actions';
import { YardSpotConfigurationModel } from '../../models';
import { take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class YardSpotConfigurationFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<ListServerPaginationStateModel<YardSpotConfigurationModel>> = this.store.select(
    YardSpotConfigurationState.getYardSpots,
  );
  loaded$: Observable<boolean> = this.store.select(YardSpotConfigurationState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.YardSpots)
      .pipe(take(1))
      .subscribe(() => {
        this.store.dispatch(new YardSpotListLoad());
      });
  }

  saveYardSpot(data: YardSpotConfigurationModel, dialog: MatDialogRef<unknown>): void {
    this.store.dispatch(
      new YardSpotSave({
        data,
        dialog,
      }),
    );
  }

  deleteYardSpot(dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>, id: number): void {
    this.store.dispatch(
      new YardSpotDelete({
        dialog,
        id,
      }),
    );
  }

  setInitialState(): void {
    this.store.dispatch(new YardSpotListInitialState());
  }
}
